import { render, staticRenderFns } from "./BahanBangunanSidebar.vue?vue&type=template&id=31b3d377&scoped=true&"
import script from "./BahanBangunanSidebar.vue?vue&type=script&lang=js&"
export * from "./BahanBangunanSidebar.vue?vue&type=script&lang=js&"
import style0 from "./BahanBangunanSidebar.vue?vue&type=style&index=0&id=31b3d377&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31b3d377",
  null
  
)

export default component.exports